import React, { useState, useEffect } from 'react'
import ColorButton from '../Buttons/ColorButton'
import apptheme from '../theme/default'
import Users from './Users'
import { Box } from '@mui/material'
import './styles.css'

import ReplyIcon from '@mui/icons-material/Reply';
import DefButton from '../Buttons/defbutton'

import GroupIcon from '@mui/icons-material/Group';
import Person2Icon from '@mui/icons-material/Person2';
import EmailIcon from '@mui/icons-material/Email';
import LeakAddIcon from '@mui/icons-material/LeakAdd';
import SearchIcon from '@mui/icons-material/Search';
import { isAdmin } from '../Utils/groups'
import Profile from './Profile'
import Email from './Email'
import { useWindowSize } from "@uidotdev/usehooks";
import { hasPermissions } from '../Utils/groups'
import ConfiguracoesToggle from '../Configuracoes'
import WorkIcon from '@mui/icons-material/Work';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SubmenuCard from '../Utils/submenuCard'
import GrupoFilial from './Comercial/GrupoFilial'
import PrecoMinimo from './Comercial/PrecoMinimo'
import PedidoConfigs from './Order'
import TipoDoc from './Order/tipodoc'
import CondPag from './Order/condpag'
import Pending from './Order/pending'
import SettingsConsultas from './Consultas'

const CalcWidthSize = (size) => {
    const threshold = size?.width < 768 ? 200 : 400
    const calcSize = Math.round(size?.width / threshold)
    if (!calcSize)
        return 2
    return calcSize
}

const MenuList = () => ({
    'users': {
        title: 'Configurar Usuários',
        icon: (<GroupIcon />),
        obj: (<Users />),
        permission: (isAdmin)
    },
    'profile': {
        title: 'Perfil',
        icon: (<Person2Icon />),
        obj: (<Profile />),
        permission: true
    },

    'email': {
        title: 'Email',
        icon: (<EmailIcon />),
        obj: (<Email />),
        permission: (isAdmin)
    },
    'integrations': {
        title: 'Querys do sistema',
        icon: (<LeakAddIcon />),
        obj: (<ConfiguracoesToggle />),
        permission: (false)
    },
    'tabela': {
        title: 'Tabela',
        icon: (<WorkIcon />),
        obj: (<></>),
        permission: (hasPermissions('administrador', 'grupo_administradores')),
        submenu: true,
        submenuList: {
            'grupo_filial': { title: 'Grupo Filial', obj: (<GrupoFilial />) },
            'preco_minimo': { title: 'Preço Mínimo', obj: (<PrecoMinimo />) }
        }
    },
    'pedido': {
        title: 'Pedido',
        icon: (<LocalShippingIcon />),
        obj: (<></>),
        permission: (hasPermissions('administrador', 'grupo_administradores')),
        submenu: true,
        submenuList: {
            'cond_pag': { title: 'Condição de pagamento', obj: (<CondPag />) },
            'tipo_doc': { title: 'Tipo documento', obj: (<TipoDoc />) },
            'general_conf': { title: 'Configurações Gerais', obj: (<PedidoConfigs />) },
            'pending': { title: 'Pendências', obj: (<Pending />), noback: true }
        }
    },
    'consultas': {
        title: 'Consultas',
        icon: (<SearchIcon />),
        obj: (<SettingsConsultas />),
        permission: (hasPermissions('administrador', 'grupo_administradores'))
    },
})

const Settings = () => {
    const [selectedTab, setSelectedTab] = useState(null)
    const [selectedSubmenu, setSelectedSubmenu] = useState(null)
    const size = useWindowSize();
    const menulist = MenuList()

    const calcSize = CalcWidthSize(size)

    const itens = Object.entries(menulist).filter(([key, value]) => value.permission)

    useEffect(() => {
        window.backtobase = () => setSelectedTab(null)
    }, [])

    return (
        <>
            {selectedTab === null ? (
                <Box className='gridBox' sx={{ gridTemplateColumns: `repeat(${calcSize}, minMax(0, 1fr))` }}>
                    {itens.map(([key, value]) => (
                        <React.Fragment key={key}>
                            {!value.submenu ? (
                                <ColorButton
                                    onClick={() => setSelectedTab(key)}
                                    sx={{ height: '8rem', flex: 1, visibility: !value.obj ? 'hidden' : 'visible' }}
                                    fColor={apptheme.primaryColor}
                                    sColor={apptheme.tertiaryColor}
                                >
                                    <Box className='flexbox'>
                                        {value.icon}
                                        {value.title}
                                    </Box>
                                </ColorButton>
                            ) : (
                                <SubmenuCard value={value} cardName={key} setSelectedTab={setSelectedTab} setSelectedSubmenu={setSelectedSubmenu} />
                            )}
                        </React.Fragment>
                    ))}
                </Box>
            ) : (
                <>
                    {(!selectedSubmenu || !menulist[selectedTab]?.submenuList?.[selectedSubmenu]?.noback) && (
                        <Box className='settings-back-button'>
                            <DefButton onClick={() => { setSelectedTab(null); setSelectedSubmenu(null) }}>
                                <ReplyIcon />
                            </DefButton>
                        </Box>
                    )}

                    {selectedSubmenu
                        ? menulist[selectedTab].submenuList[selectedSubmenu]?.obj
                        : menulist[selectedTab]?.obj}
                </>
            )}

        </>
    )
}

export default Settings